App.factory('Contact', ['restmod', restmod => restmod.model('/contacts')])
